export const METRICS_PAGE_ID = 'board-settings-apps.card-layout-page';

export const JIRA_SOFTWARE_BOARD_SETTINGS_ARTICLE_ID_CARD_LAYOUT = '10DTPAc0QDeqKK20lm2qK9';
export const JIRA_SERVICEDESK_BOARD_SETTINGS_ARTICLE_ID_CARD_LAYOUT = '4UiZ7BjclclQcc5FeA2SKX';
export const BOARD_SETTINGS_ARTICLE_ID_CARD_LAYOUT_ANALYTICS_ID = `${METRICS_PAGE_ID}.cmp.article.analytics`;

export const PLAN_MODE = 'planMode' as const;
export const WORK_MODE = 'workMode' as const;
